import React, { useState, useEffect } from 'react';
import SelectColourButton from './selectColourButton';
import { Radio } from 'react-bootstrap';

const DEFAULT_OTHER_CONFIG = { audio_codec: '', callType: '' };

export default function WebcamEditModule({ eventModuleRow, updateEventModuleRow, customerFeatures }) {
    const [webcamName, setWebcamName] = useState(eventModuleRow.name);
    const [bStyle, setBStyle] = useState(eventModuleRow.colour);
    const [other_config, setOtherConfig] = useState(
        eventModuleRow.other_config && Object.entries(eventModuleRow.other_config).length === 2
            ? eventModuleRow.other_config
            : DEFAULT_OTHER_CONFIG
    );
    const [features] = useState(() => {
        const f = { audio: false, videoAudio: false, videoOnly: false };
        for (const cf of customerFeatures) {
            if (cf.module_type_id === eventModuleRow.module_type_id) {
                for (const feat of cf.features.split(',')) {
                    f[feat] = true;
                }
            }
        }
        return f;
    });

    useEffect(() => {
        setWebcamName(eventModuleRow.name);
        setBStyle(eventModuleRow.colour);
        if (eventModuleRow.other_config && Object.entries(eventModuleRow.other_config).length === 2) {
            setOtherConfig(eventModuleRow.other_config);
        }
    }, [eventModuleRow]);

    function notify(overrides) {
        updateEventModuleRow({
            name: webcamName,
            colour: bStyle,
            other_config,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
            ...overrides,
        });
    }

    function handleChange(e) {
        if (e.target.name === 'webcamName') {
            const newName = e.target.value;
            setWebcamName(newName);
            notify({ name: newName });
        } else if (e.target.name === 'ISAC') {
            const newConfig = { ...other_config, audio_codec: other_config.audio_codec === '' ? 'ISAC' : '' };
            setOtherConfig(newConfig);
            notify({ other_config: newConfig });
        }
    }

    function radioButtonClicked(e) {
        const newConfig = { ...other_config, callType: e.target.value };
        if (e.target.value === 'video') newConfig.audio_codec = '';
        setOtherConfig(newConfig);
        notify({ other_config: newConfig });
    }

    function colourSelected(newStyle) {
        setBStyle(newStyle);
        notify({ colour: newStyle });
    }

    const isacDisabled = other_config.callType !== 'audio';

    return (
        <div>
            <input type="text" style={{ width: '50%' }} className="form-control input-md"
                name="webcamName" value={webcamName}
                onChange={handleChange} placeholder="Webcam Name" />
            <SelectColourButton
                title="Select Colour"
                groupingSequence={eventModuleRow.event_grouping_seq}
                selectedColour={colourSelected}
                bStyle={bStyle} />
            <br />
            <input name="ISAC"
                style={{ marginRight: '10px' }}
                checked={other_config.audio_codec === 'ISAC'}
                onChange={handleChange}
                disabled={isacDisabled}
                type="checkbox" value="" />
            Use Codec ISAC for audio
            <br />
            <Radio name="callType" inline value="audio" disabled={!features.audio}
                checked={other_config.callType === 'audio'} onChange={radioButtonClicked}>
                Audio
            </Radio>{' '}
            <Radio name="callType" value="videoAudio" disabled={!features.videoAudio} inline
                checked={other_config.callType === 'videoAudio'} onChange={radioButtonClicked}>
                Video With Audio
            </Radio>{' '}
            <Radio name="callType" value="videoOnly" disabled={!features.videoOnly} inline
                checked={other_config.callType === 'videoOnly'} onChange={radioButtonClicked}>
                Video No Audio
            </Radio>
        </div>
    );
}
